import * as React from 'react';
import { FixedHeader } from '../FixedHeader';
import { Introduction } from '../Introduction';
import { About } from '../About';
import { MortgageCalculatorSection } from '../MortgageCalculatorSection';
import { Ratings } from '../Ratings';
import { SpecialPromos } from '../SpecialPromos';
import { Projects } from '../Projects';
import { ProjectsOnMap } from '../ProjectsOnMap';
import { Mortgage } from '../Mortgage';
import { Benefits } from '../Benefits';
import { VideoSection } from '../VideoSection';
import { News } from '../News';
import { InstagramSection } from '../InstagramSection';
import { Documentation } from '../Documentation';
import { MainContentWrapper } from '../../components/MainContentWrapper';

export const Page = () => {
  return (
    <MainContentWrapper>
      <FixedHeader />
      <Introduction />
      <About />
      <MortgageCalculatorSection />
      <Ratings />
      <SpecialPromos />
      <Projects />
      <ProjectsOnMap />
      <Mortgage />
      <Benefits />
      <VideoSection />
      <News />
      <InstagramSection />
      <Documentation />
    </MainContentWrapper>
  );
};
